<template>
    <div class="section-images-grid-second">
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].cards" :key="item.title">
                <div class="item-desc">
                    <h4 v-html="item.title"></h4>
                    <p v-html="item.desc" v-if="options[0].init_desc"></p>
                </div>
                <div class="item-img" :style="'background-image:url(' + item.img + ')'"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'section-images-grid-second',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/section-images-grid-second.scss';
    @import '@/styles/components/partials/respond/section-images-grid-second-respond.scss';
</style>